export default __webpack_public_path__ + "static/media/Yoga-Studio.d7fc572b.webp";